import type { LucideIcon } from 'lucide-react';
import {
  ArrowLeftRight,
  ClipboardList,
  Dna,
  Droplets,
  Layers,
  LayoutDashboard,
  ShoppingBag,
  Tags,
  TrendingUp,
} from 'lucide-react';
import type { MessageKey } from '@/lib/i18n';

export type AppNavItem = {
  to: string;
  icon: LucideIcon;
  labelKey: MessageKey;
  /** Rótulo mais curto no menu inferior mobile */
  mobileLabelKey?: MessageKey;
  end?: boolean;
  /** Exige módulo do cliente ativo */
  module?: string;
  /** Exige atividade da propriedade ativa */
  activity?: string;
};

export const appNavItems: AppNavItem[] = [
  { to: '/', icon: LayoutDashboard, labelKey: 'nav.dashboard', end: true },
  { to: '/animais', icon: Tags, labelKey: 'nav.animals' },
  { to: '/lotes', icon: Layers, labelKey: 'nav.lots' },
  { to: '/eventos', icon: ClipboardList, labelKey: 'nav.events' },
  {
    to: '/movimentacoes',
    icon: ArrowLeftRight,
    labelKey: 'nav.movements',
    mobileLabelKey: 'nav.movements.short',
  },
  {
    to: '/reproducao',
    icon: Dna,
    labelKey: 'nav.reproduction',
    mobileLabelKey: 'nav.reproduction.short',
  },
  {
    to: '/zootecnia',
    icon: TrendingUp,
    labelKey: 'nav.indicators',
    mobileLabelKey: 'nav.indicators.short',
  },
  {
    to: '/controle-leiteiro',
    icon: Droplets,
    labelKey: 'nav.dairy',
    mobileLabelKey: 'nav.dairy.short',
  },
  { to: '/vendas', icon: ShoppingBag, labelKey: 'nav.sales', module: 'animal_sales' },
];

export function filterNavByModules(
  items: AppNavItem[],
  modules?: Record<string, boolean> | null,
  propertyActivities?: string[] | null,
): AppNavItem[] {
  return items.filter((item) => {
    if (item.module && !modules?.[item.module]) return false;
    if (item.activity && !(propertyActivities ?? []).includes(item.activity)) return false;
    return true;
  });
}
